module.exports = __webpack_public_path__ + "static/media/logo.bcf9eda9.jpg";